import { Chip, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { incomes, services } from './utils';
import * as Styled from './styles';
import { IncomeProps } from './types';

const IncomeFilter = ({ stateFunctions, isPayLater, data }: IncomeProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);
  const { variable, products, updateIncomes, updateProducts } = stateFunctions;
  return (
    <FlexContainer direction="column">
      {data && data.length > 3 && (
        <Styled.Accordion mb="fds_size_32">
          <Text type="paragraphs" color="grey" size="M_L_S">
            {t('Plans.filter.income.question')}
          </Text>
          <FlexContainer gap="dimension_08" mb="fds_size_24" wrap="wrap">
            {incomes.map(({ label, id }) => (
              <Chip
                key={id}
                type={variable[id] ? 'cold' : 'cold_line'}
                size="L"
                onClick={() => {
                  updateIncomes(id);
                }}
              >
                {t(label)}
              </Chip>
            ))}
          </FlexContainer>
        </Styled.Accordion>
      )}
      <Styled.Accordion mb="fds_size_32">
        <Text type="paragraphs" color="grey" size="M_L_S" align="start">
          {t('Plans.filter.service.title')}
        </Text>
        <FlexContainer gap="dimension_08" wrap="wrap" mb="fds_size_24">
          {services.map(({ label, id }) => (
            <Styled.Chip
              key={id}
              type={products[id] ? 'cold' : 'cold_line'}
              size="L"
              onClick={() => {
                updateProducts(id);
              }}
              isPayLater={!isPayLater && id === 'payLater'}
            >
              {t(label)}
            </Styled.Chip>
          ))}
        </FlexContainer>
      </Styled.Accordion>
      <Styled.DesktopContainer direction="column">
        {data && data.length > 3 && (
          <>
            <Text type="paragraphs" color="cold" size="L_L_S" mb="fds_size_40">
              {t('Plans.filter.title')}
            </Text>
            <Text type="paragraphs" color="grey" size="M_L_S" mb="fds_size_16">
              {t('Plans.filter.income.question')}
            </Text>
            <FlexContainer gap="dimension_08" mb="fds_size_24" wrap="wrap">
              {incomes.map(({ label, id }) => (
                <Chip
                  key={id}
                  type={variable[id] ? 'cold' : 'cold_line'}
                  size="L"
                  onClick={() => {
                    updateIncomes(id);
                  }}
                >
                  {t(label)}
                </Chip>
              ))}
            </FlexContainer>
          </>
        )}
        <Text type="paragraphs" color="grey" size="M_L_S" mb="fds_size_16" align="start">
          {t('Plans.filter.service.title')}
        </Text>
        <FlexContainer gap="dimension_08" wrap="wrap" mb="fds_size_24">
          {services.map(({ label, id }) => (
            <Styled.Chip
              key={id}
              type={products[id] ? 'cold' : 'cold_line'}
              size="L"
              onClick={() => {
                updateProducts(id);
              }}
              isPayLater={!isPayLater && id === 'payLater'}
            >
              {t(label)}
            </Styled.Chip>
          ))}
        </FlexContainer>
      </Styled.DesktopContainer>
    </FlexContainer>
  );
};

export default IncomeFilter;
